export default {
    en: {
        id: 'exercise5',
        answers: [
            {
                title: `<div class="box-title">Unhappy with the rankings</div>
                      <div>
                          #5 In business relationship
                      </div>
                      <div>
                          #4 in Personnel/organization
                      </div>
                      <div>
                          #4 in Category/Business Development
                      </div>
                      <div>
                          #3 in Retail Execution
                      </div>
                      <div>
                          #2 in Supply Chain Management
                      </div>
                      <div>
                          #2 in overall performance
                      </div>`,
                answer: 1,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Set up teams to determine steps needed to move up</div>`,
                answer: 2,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Regain #2 and move toward #1</div>`,
                answer: 3,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Identified likely causes of the low ratings</div>`,
                answer: 4,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Annual survey by Advantage International</div>
                      <div>
                          - Interviewed 47 manufacturers about Winters
                      </div>
                      <div>
                          - Compared us to 6 competitors
                      </div>`,
                answer: 5,
                hasArrow: true
            }
        ],
        image: 'section-5b-5.png'
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5b/practiceDefiningProblem/i18n/exercise5.js